import React from 'react'

const PartNine = () => {
  return (
    <><br/>
        <div className="row">
            <div className="col-xl-12 col-md-12">
                <br/>
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>หมวดที่ 6 คุณภาพวัสดุอุปกรณ์ เครื่องมือ เครื่องใช้ และสัมภาระ</strong>
                </p> 
            </div>
        </div>
        <div className="row">
            <div className="col-xl-12 col-md-12 d-flex align-items-center">
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;6.1 วัสดุ เครื่องจักร และอุปกรณ์ทุกชนิด จะต้องเหมาะสมกับลักษณะของงานที่ว่าจ้าง และคุณภาพดีตามที่ระบุไว้ในเอกสารแนบท้าย
                </p> 
            </div>
        </div>
    </>  
  )
}

export default PartNine